export default "__VITE_ASSET__BJGQ81Ub__"